<template>
    <st-input-block-styled :width="width" :block="block" :size="size" :icon="icon">
        <st-input-styled
            v-model="_value"
            :type="type"
            ref="stInput"
            :readonly="readonly"
            :disabled="disabled"
            :placeholder="placeholder"
            @keypress="keyPressHandler"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            @keyup="keyUpHandler"
        />

        <div v-if="icon" class="st-input-icon">
            <awesome-icon :name="icon" />
        </div>
    </st-input-block-styled>
</template>
<script>
import styled, { css } from "vue-styled-components";

export const props = {
    width: Number,
    block: Boolean,
    icon: String,
    size: {
        type: String,
        default: () => "middle"
    }
};

const StInputBlockStyled = styled("div", props)`
    display: inline-block;
    position: relative;

    ${props =>
        props.block
            ? css`
                  width: 100%;
              `
            : props.width &&
              css`
                  width: ${props.width}rem;
              `}

    .st-input-icon {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        width: ${props => props.theme.size[props.size]}rem;
        height: ${props => props.theme.size[props.size]}rem;
        font-size: 1.6rem;
        justify-content: center;
        align-items: center;
        color: ${props => props.theme.color.disabled};
        transition: color 0.25s;
    }

    input {
        height: ${props => props.theme.size[props.size]}rem;

        ${props =>
            props.icon
                ? css`
                      padding-left: ${props => props.theme.size[props.size]}rem;
                  `
                : css`
                      padding-left: 1.6rem;
                  `}
    }
`;

const StInputStyled = styled.input`
    width: 100%;

    outline: none;
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 5px;
    font-size: 1.4rem;
    padding-right: 1.6rem;

    &::placeholder {
        font-size: 1.4rem;
    }

    &:focus {
        border-color: ${props => props.theme.color.primary};

        & + .st-input-icon {
            color: ${props => props.theme.color.primary};
        }
    }

    &:disabled {
        ${props => props.theme.box.disabled};
    }

    &[readonly="readonly"] {
        ${props => props.theme.box.readonly};
    }
`;

export default {
    name: "StInput",
    data: () => ({
        localValue: null
    }),
    props: {
        ...props,
        placeholder: String,
        value: String,
        pattern: String,
        type: {
            type: String,
            default: () => "text"
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        readonly: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        _value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    methods: {
        keyPressHandler(ev) {
            // code in mac
            // key in window && mac
            if (ev.code === "Enter" || ev.key === "Enter") {
                this.$emit("enter", ev);
            }

            this.$emit("keypress", ev);
        },

        keyUpHandler(ev) {
            const { value } = ev.target;

            if (this.pattern === "number" && !/^[0-9]+$/.test(value)) {
                this.$emit("input", value.slice(0, value.length - 1));
                ev.preventDefault();
            }

            this.$emit("keyup", ev);
        },

        focus() {
            this.$refs.stInput.$el.focus();
        }
    },
    components: {
        StInputBlockStyled,
        StInputStyled
    }
};
</script>
